import {ApiModel} from './api-model';
import {Picture} from './picture';
import {Language} from './language';
import { Format } from './format';

export class TranslationValue extends ApiModel {
  orderId: number;
  value: any;
  modified: boolean;
  initialValue: any;
  language: Language;
  id: number;

  constructor(data: any, picture = false) {
    super(data);
    this.modified = false;
    if (picture) {
      if(data.format){
        this.value = new Format(data);
      }
      else{
        this.value = new Picture(data);
      }
    }
    this.initialValue = this.value;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/translation-value.ts